import { render, staticRenderFns } from "./CtaBand.vue?vue&type=template&id=2aa03359&scoped=true"
import script from "./CtaBand.vue?vue&type=script&lang=js"
export * from "./CtaBand.vue?vue&type=script&lang=js"
import style0 from "./CtaBand.vue?vue&type=style&index=0&id=2aa03359&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa03359",
  null
  
)

export default component.exports